"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var donutGaugeColors = {
    default: '#eeeeee',
    remaining: '#eeeeee',
    basic: '#483d8b',
    white: '#FFFFFF',
    info: '#23c6c8',
    danger: '#ED5565',
    warning: '#f8ac59',
    success: '#1c84c6',
    primary: '#72c02c'
};
exports.donutGaugeColors = donutGaugeColors;
//# sourceMappingURL=donutGaugeColors.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/donutGaugeColors.js
// module id = 869
// module chunks = 0